import { z } from "zod";

export const locationSearchSchema = z.object({
  locationId: z.string().min(1, "Required"),
});
